import { useWallet } from '@solana/wallet-adapter-react';
import { WalletMultiButton } from '@solana/wallet-adapter-material-ui';
import { useHistory } from 'react-router-dom';
import { styled } from '@mui/system';
import MenuIcon from '@material-ui/icons/Menu';
import Drawer from '../Drawer';
import { useState, FC } from 'react';
import { routes } from '../../../router/routes';
import { IconButton } from '@material-ui/core';
export const StyledWalletButton = styled(WalletMultiButton)`
  color: rgb(55, 65, 81, 1);
  &:hover {
    background: none !important;
  }
  .wallet-adapter-button {
    padding: 0px;
  }
`;
export const TitleText = styled('div')`
  @media (max-width: 550px) {
    font-size: 14px;
  }
`;

export interface HeaderProps {
  onBackNavigation?: () => void;
}
const Header: FC<HeaderProps> = ({ onBackNavigation }) => {
  const { push, location } = useHistory();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { connected, publicKey } = useWallet();

  const MOBILE_NAV_LINKS_LIST = [
    { label: 'Home', target: "/" },
    // { label: 'Stake', target: routes.STAKE },
    { label: 'Website', target: "https://website.com" },
    { label: 'Tokenomics', target: "https://google.com" },
    { label: 'Discord', target: "https://google.com" },
  ];
  return (
    <div className="w-full lg:px-10">
      <div className={' flex justify-between items-center p-6 lg:hidden'}>
        <div className="MBJChunky md:text-3xl text-xl text-white">
          <div
            onClick={() => push('/')}
            className="relative z-10 MBJChunky cursor-pointer"
          >
            MOM RAFFLE
          </div>
        </div>
        <IconButton size={'medium'} onClick={() => setIsDrawerOpen(true)}>
          <MenuIcon className="text-white" />
        </IconButton>
        <Drawer
          wallet={publicKey}
          isOpen={isDrawerOpen}
          setIsOpen={setIsDrawerOpen}
          navLinksList={MOBILE_NAV_LINKS_LIST}
        />
      </div>
      <div
        className={`hidden lg:flex md:pt-6 justify-between bg-green-00 md:px-6`}
      >
        <div className="container bg-red-00 flex justify-between relative my-auto mx-auto w-full items-center md:px-6 align-middle">
          <div className="MBJChunky md:text-3xl text-xl text-white">
            <div
              onClick={() => push('/')}
              className="relative z-10 MBJChunky cursor-pointer"
            >
              MOM RAFFLE
            </div>
          </div>
          <div className="textbtn flex bg-yellow-00 justify-end items-center flex-1">
            <div className=" flex justify-between md:space-x-10 space-x-3 md:text-lg text-white bg-green-00">
              <div className="GTWalsheimProBold">Website</div>
              <div className="GTWalsheimProBold">Tokenomics</div>
              <div className="GTWalsheimProBold">Discord</div>
            </div>
            <div className="flex bg-yellow-00 justify-end pl-6">
              <WalletMultiButton
                style={{
                  fontSize: '14px',
                  zIndex: 10,
                  height: '38px',
                  border: 'none',
                  backgroundColor: '#34302A',
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="absolute top-0 left-0 overflow-hidden">
        {' '}
        <img
          style={{ zIndex: -1 }}
          src="/image/PinkSapphire.png"
          className="md:w-96 w-28"
        />{' '}
      </div>
    </div>
  );
};

export default Header;
